/**
 * The words shown beside the "under 18" tick on a club's member form.
 *
 * Mirror of the app's junior_members.dart — change both together.
 *
 * WHY A TICK AND NOT A DATE. Every junior protection only needs to know WHETHER
 * someone is a child. A date of birth typed by an admin about somebody else's
 * child is more than that purpose needs, and a guessed one is worse than none
 * for looking authoritative while being wrong.
 */

/** The label on the checkbox. */
export const JUNIOR_TICK_LABEL = 'Under 18';

/**
 * Shown under the tick. It states the precedence, because an admin who ticks a
 * member and then sees nothing change deserves to know why.
 */
export const JUNIOR_TICK_HELP =
  'Turns on the privacy settings we apply to children. If this member has an account and gives us their own date of birth, that is used instead.';

/**
 * The chip beside a junior on the club admin members page.
 *
 * Reads `under18`, the RESOLVED answer (their own date of birth where they
 * gave one, the tick otherwise). The API sends it only to club admins of a club
 * the person plays in and to super admins, and never on a public or embed
 * payload, so an absent value simply means "not yours to know" and shows
 * nothing. `isJunior` is the raw tick and would mark the wrong people.
 */
export const UNDER_18_CHIP = 'Under 18';
export const showUnder18Chip = (member) => member?.under18 === true;

/**
 * Under the date of birth on your own profile. Own account only: `isJunior`
 * on the signed-in user is resolved by the API from the date of birth or the
 * tick. Mirror of the app's junior_members.dart.
 */
export const OWN_JUNIOR_NOTE = "You're under 18, so some things work differently for you.";
export const showOwnJuniorNote = (user) => user?.isJunior === true;
